export const GET = {
  REQUEST: 'Subcontractors/Get/Request',
  SUCCESS: 'Subcontractors/Get/Success',
  FAILURE: 'Subcontractors/Get/Failure'
};
